<template>
    <v-dialog v-model="isActive" width="550">
        <template>
            <v-card>
                <div
                    style="height: 5vh; background-color: #E5E4E2; display: flex; align-items: center; padding-left: 20px;">
                    <h5>Upload Your .Xlsx File</h5>
                </div>
                <div style="padding: 1.5rem;">
                    <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                        <input type="file" name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
                            accept=".xlsx" />

                        <v-icon size="70" style="color: #E5E4E2;">
                            mdi-file-upload-outline
                        </v-icon>
                        <div class="text-center" v-if="isUploading">
                            <br />
                            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                            <div style="font-weight: bold; font-size: small;">Updating quarterly research data based on
                                the provided CSV file.</div>
                            <div style="color:#708090; font-weight: bold; font-size: x-small; text-align: center;">
                                Please wait...</div>
                        </div>
                        <div v-else>
                            <label v-if="!readingInProgress" for="fileInput" class="file-label">
                                <div v-if="isDragging" style="font-weight: bold; font-size: small;">Release to drop your
                                    file here.</div>
                                <div v-else style="font-weight: bold; font-size: small;">Drag and Drop or <u>Click</u>
                                    to
                                    upload the file.</div>
                                <div style="color:#E5E4E2; font-weight: bold; font-size: x-small; text-align: center;">
                                    Supported Formats: .xlsx Max File Size: 25MB</div>
                            </label>

                            <label v-else for="fileInput" class="file-label">
                                <div style="font-weight: bold; font-size: small;">{{ processedRows }} rows proccessed.</div>
                                <div style="color:#E5E4E2; font-weight: bold; font-size: x-small; text-align: center;">
                                    This may taks a few minutes.
                                </div>
                                <div style="color:#E5E4E2; font-weight: bold; font-size: x-small; text-align: center;">
                                    Please wait!
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- <DropFile/> -->
            </v-card>
        </template>
    </v-dialog>
</template>

<script>
import cityService from '../services/city.service';
export default {
    data() {
        return {
            isActive: false,
            isDragging: false,
            files: [],
            isUploading: false,
            readingInProgress: false,
            pollingTimer: null,
            currentJobId: null,
            processedRows: 0
        };
    },
    components: {
    },
    beforeDestroy() {
        if (this.pollingTimer) clearInterval(this.pollingTimer);
    },
    methods: {
        uploadFiles() {
            this.isUploading = true;
            const files = this.files;
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("file", file);
            });
            try {
                cityService.UploadResearch(formData).then((res) => {
                    this.files = [];
                    this.isUploading = false;
                    if (res.status == 202) {
                        this.files = [];
                        const jobId = res.data.jobId; // Capture the ID from your backend response
                        this.currentJobId = jobId;
                        this.readingInProgress = true;

                        // Start checking status every 5 seconds
                        this.startStatusPolling(jobId);

                        let payload = {
                            snackBarText: `Upload started! Processing rows...`,
                            snackBarColor: "info",
                        };
                        this.$store.dispatch("notify/setSnackbarMessage", payload);
                    }
                });
            } catch (error) {
                let payload2 = {
                    snackBarText: `Having trouble uploading the file!`,
                    snackBarColor: "error",
                };
                this.$store.dispatch("notify/setSnackbarMessage", payload2);
            }
        },
        startStatusPolling(jobId) {
            // Clear any existing timer just in case
            if (this.pollingTimer) clearInterval(this.pollingTimer);

            this.pollingTimer = setInterval(() => {
                this.checkUploadStatus(jobId);
            }, 5000); // 5000ms = 5 seconds
        },
        checkUploadStatus(jobId) {
            cityService.GetResearchStatus(jobId).then((res) => {
                const { status, processedRows, error } = res.data;
                this.processedRows = processedRows;

                if (status === "completed") {
                    this.readingInProgress = false;
                    this.currentJobId = null;
                    this.stopPolling("Research data fully processed!", "success");
                } else if (status === "failed") {
                    this.readingInProgress = false;
                    this.currentJobId = null;
                    this.stopPolling(`Processing failed: ${error}`, "error");
                } else {
                    console.log(`Still processing... Rows: ${processedRows}`);
                }
            }).catch(err => {
                console.error("Polling error:", err);
                this.stopPolling("Lost connection to status update.", "error");
            });
        },
        stopPolling(message, color) {
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
            this.readingInProgress = false;

            this.$store.dispatch("notify/setSnackbarMessage", {
                snackBarText: message,
                snackBarColor: color,
            });
            this.isActive = false;
        },
        onChange() {
            const self = this;
            let incomingFiles = Array.from(this.$refs.file.files);
            const fileExist = self.files.some((r) =>
                incomingFiles.some(
                    (file) => file.name === r.name && file.size === r.size
                )
            );
            if (fileExist) {
                self.showMessage = true;
                alert("New upload contains files that already exist");
            } else {
                self.files.push(...incomingFiles);
                this.uploadFiles()
            }
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            const droppedFiles = e.dataTransfer.files;
            this.files.push(...Array.from(droppedFiles));
            this.isDragging = false;
            this.onChange();
        }

    }
};
</script>
<style scoped>
.dropzone-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 25vh;
    border-radius: 5px;
    border: 2px dashed #35a7ff;
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}

.preview-card {
    display: flex;
    border: 1px solid #a2a2a2;
    padding: 5px;
    margin-left: 5px;
}

.preview-img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #a2a2a2;
    background-color: #a2a2a2;
}
</style>